import {AccountSuccessResponse, GetAccountResponseBody} from '@/types/payments';

export const isAccountSuccessResponse = (
  response: GetAccountResponseBody
): response is AccountSuccessResponse => {
  return (response as AccountSuccessResponse).charges_enabled !== undefined;
};
